import {
  debounce
} from 'lodash';
import { loadMinicart } from '../../scripts/components/minicart';
import './template-cart.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initTemplateCart = (context) => {
  const templateCartSection = context.closest('.shopify-section');
  if (!templateCartSection) return;
  const cartWrapper = templateCartSection.querySelector('.cart-section');
  if (!cartWrapper) return;

  const lineUpdate = (productRow, lineIndex, newValue) => {
    cartWrapper.classList.add('is-loading');
    ShopifyAPI.changeItem(
      lineIndex,
      newValue,
      async (cart) => {
        const inputEl = productRow.querySelector(
          'input.cart-form__product-qty-value',
        );
        if (inputEl) inputEl.value = newValue;
        await loadMinicart();
        if (newValue == 0) productRow.remove();
        cartWrapper.classList.remove('is-loading');
        const totalPrice = cartWrapper.querySelector('[data-total-price]');
        const linePrice = productRow.querySelector('span.cart__form__row__price');
        const cartLine = cart.items.at(
          parseInt(productRow.dataset.cartLineIndex) - 1,
        );
        if (cartLine && linePrice)
          linePrice.innerText = theme.Currency.formatMoney(
            cartLine.final_line_price,
            theme.strings.moneyFormat,
          );
        if (totalPrice)
          totalPrice.innerText = theme.Currency.formatMoney(
            cart.total_price,
            theme.strings.moneyFormat,
          );
      },
      (XMLHttpRequest, textStatus) => {
        cartWrapper.classList.remove('is-loading');
      },
    );
  };

  const initQtyButtons = () => {
    templateCartSection
      .querySelectorAll('.cart__form__row--product[data-cart-line-index]')
      .forEach((productRow) => {
        const lineIndex = productRow.dataset.cartLineIndex;
        const qtyContainer = productRow.querySelector(
          '.cart__form__row__element--quantity',
        );
        if (qtyContainer) {

          const qtyInput = qtyContainer.querySelector(
            '.cart__form__row__element--quantity-value',
          );

          if (qtyInput) {
            const stock =
              qtyInput?.dataset?.stock >= 0 ? qtyInput.dataset.stock : -1;

            qtyInput.addEventListener('change', (e) => {
              const newValue = parseInt(qtyInput.value);
              if (stock >= 0) {
                if (stock >= newValue) {
                  lineUpdate(productRow, lineIndex, newValue);
                }
              } else {
                lineUpdate(productRow, lineIndex, newValue);
              }
            });
          }
        }

        const removeLink = productRow.querySelector(
          'a.cart-form__product-remove',
        );
        if (removeLink && removeLink.href) {
          removeLink.addEventListener('click', (e) => {
            e.preventDefault();
            lineUpdate(productRow, lineIndex, 0);
          });
        }
      });
  };

  const initCartPage = () => {
    const form = templateCartSection.querySelector('form');
    if (!form) return;
    $(form).parsley();
    initQtyButtons();
  };

  initCartPage();
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
    window.dAgency.initTemplateCart(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.cart-section'), (el) => {
      window.dAgency.initTemplateCart(el);
    });
  });
}
